/* unplugin-vue-components disabled */import { render } from "./PopupPickerCpt.vue?vue&type=template&id=4687f746"
import script from "./PopupPickerCpt.vue?vue&type=script&lang=js"
export * from "./PopupPickerCpt.vue?vue&type=script&lang=js"

import exportComponent from "D:\\源码\\frontend\\vue-wms-mobile-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__